import DOMPurify from 'dompurify';

// Formatting tags the payer may embed in disclaimer copy. Kept intentionally
// tight — no scripts, styles, attributes or event handlers — since the text is
// rendered via dangerouslySetInnerHTML.
// ⚠️ If this list is ever widened to a tag that carries a URL (e.g. `a`, `img`),
// `ALLOWED_ATTR` must stay empty OR add an `ALLOWED_URI_REGEXP` scheme guard,
// otherwise `javascript:` / `data:` URIs reintroduce an XSS vector.
const ALLOWED_TAGS = ['b', 'strong', 'i', 'em', 'u', 'br', 'p'];

export const sanitizeDisclaimerHtml = (html: string): string =>
  DOMPurify.sanitize(html, {
    ALLOWED_TAGS,
    ALLOWED_ATTR: [],
  });
